/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TemplateCreateRequest } from '../../models/template-create-request';
import { TemplateResponse } from '../../models/template-response';

export interface TemplateCreate$Params {
  'Active-Tenant-Identifier': string;
  templateType: 'opts-config' | 'tender-config' | 'order-charge-limits' | 'pos-status-notifications';
      body: TemplateCreateRequest
}

export function templateCreate(http: HttpClient, rootUrl: string, params: TemplateCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TemplateResponse>> {
  const rb = new RequestBuilder(rootUrl, templateCreate.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateType', params.templateType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TemplateResponse>;
    })
  );
}

templateCreate.PATH = '/ordering/templates/{templateType}';
